module.exports = __webpack_public_path__ + "static/media/gcash-logo-v2.4728a5ac.svg";